import type { Dispatch, SetStateAction } from "react";
import type { SrChatChart } from "./sr-chat-chart-types";
import { normalizeSrCharts } from "./sr-chat-chart-types";
import type { SrNameCandidate } from "./sr-name-candidate-types";
import { normalizeNameCandidates } from "./sr-name-candidate-types";

export type SrChatRole = "user" | "assistant";

export type SrChatMessage = {
    id: string;
    role: SrChatRole;
    content: string;
    charts?: SrChatChart[];
    nameCandidates?: SrNameCandidate[];
};

export const welcome: SrChatMessage = {
    id: "welcome",
    role: "assistant",
    content:
        "Hello. I can search by name (pick a person first), summarize by status, or look up by tracking ID — text or voice.",
};

export const toHistory = (msgs: SrChatMessage[]) =>
    msgs
        .filter((m) => m.id !== "welcome")
        .map((m) => ({ role: m.role, content: m.content }));

export const newConversationId = () =>
    typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `c-${Date.now()}`;

export const appendAssistant = (
    setMessages: Dispatch<SetStateAction<SrChatMessage[]>>,
    content: string,
    charts?: SrChatChart[],
    nameCandidates?: SrNameCandidate[]
) => {
    setMessages((prev) => [
        ...prev,
        {
            id: `a-${Date.now()}`,
            role: "assistant",
            content,
            charts: charts?.length ? charts : undefined,
            nameCandidates: nameCandidates?.length ? nameCandidates : undefined,
        },
    ]);
};

export const chartsFromResponse = (data: unknown): SrChatChart[] =>
    normalizeSrCharts((data as { charts?: unknown })?.charts);

export const nameCandidatesFromResponse = (data: unknown): SrNameCandidate[] =>
    normalizeNameCandidates(
        (data as { name_candidates?: unknown })?.name_candidates
    );
